import RejectionReasonModal from "./rejection-reason-modal";

export default {
    RejectionReasonModal
};